module.exports = __webpack_public_path__ + "static/img/defaultCourseCover.9b29789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defaultCourseCover.png
// module id = 6d5220ab51df7970
// module chunks = 59